const LAYER_NAME = 'dataLayer';
const SCRIPT_TAG = 'script';

if (typeof window.isGTMStarted === 'undefined') {
  window.isGTMStarted = false;
}

function ensureLayer() {
  window[LAYER_NAME] = window[LAYER_NAME] || [];
}

export function notifyPageView() {
  ensureLayer();
  let { pathname, search } = window.location;

  if (pathname.charAt(0) === '/') {
    pathname = pathname.substr(1);
  }

  window['dataLayer'].push({
    event: 'pageView',
    virtualUrl: pathname + search
  });
}

function bindTurbolinks() {
  document.addEventListener('turbolinks:load', () => notifyPageView());
}

function notifyGTMStartup() {
  window[LAYER_NAME].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
}

function onGTMLoaded() {
  notifyGTMStartup();
  bindTurbolinks();
  window.isGTMStarted = true;
}

async function startGTM(code) {
  return new Promise((resolve, reject) => {
    ensureLayer();

    const lastScriptElement = document.getElementsByTagName(SCRIPT_TAG)[0];
    const scriptElement = document.createElement(SCRIPT_TAG);
    const params = LAYER_NAME !== 'dataLayer' ? '&l=' + LAYER_NAME : '';

    scriptElement.async = true;
    scriptElement.onload = () => resolve();
    scriptElement.onerror = error => reject(error);
    scriptElement.src =
      'https://www.googletagmanager.com/gtm.js?id=' + code + params;
    lastScriptElement.parentNode.insertBefore(scriptElement, lastScriptElement);
  });
}

async function startQCX() {
  return startGTM(RAILS_ENV === 'production' ? 'GTM-NNF97JX' : 'GTM-NPDX48V');
}

if (
  !window.isGTMStarted &&
  (RAILS_ENV === 'staging' || RAILS_ENV === 'production')
) {
  Promise.all([startQCX()].filter(Boolean))
    .then(() => onGTMLoaded())
    // eslint-disable-next-line no-console
    .catch(err => console.log('Erro ao inicializar GTM', err));
}
